import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "短片", to: "/category/short" },
  { label: "热门", to: "/category/hot" },
  { label: "关于我们", to: "/about" },
];

const categoryLinks = categories
  .filter((item) => item.key !== "all")
  .map((item) => ({ label: item.name, to: `/category/${item.key}` }));

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-800 text-background-100">
      <div className="container-page py-10 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="relative flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-accent-400">
                <span className="font-heading text-base font-semibold">色</span>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                色色视频
              </span>
            </div>
            <p className="mt-4 max-w-xs text-xs leading-relaxed text-background-300">
              多元高清视频内容聚合平台。以清晰的分类与信息层级，帮助用户便捷发现电影、短片与热门视频内容。
            </p>
            <p className="mt-3 font-label text-[10px] uppercase tracking-[0.22em] text-background-400">
              Since 2021 · Content Aggregation
            </p>
          </div>

          <div>
            <h2 className="font-label text-[11px] font-semibold uppercase tracking-[0.18em] text-background-300">
              快速导航
            </h2>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="focus-ring inline-flex text-xs text-background-200 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-label text-[11px] font-semibold uppercase tracking-[0.18em] text-background-300">
              内容分类
            </h2>
            <ul className="mt-4 space-y-2.5">
              {categoryLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="focus-ring inline-flex text-xs text-background-200 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/search"
                  className="focus-ring inline-flex text-xs text-background-200 transition-colors hover:text-accent-300"
                >
                  站内搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-label text-[11px] font-semibold uppercase tracking-[0.18em] text-background-300">
              联系与反馈
            </h2>
            <p className="mt-4 text-xs leading-relaxed text-background-300">
              内容纠错、版权说明或合作咨询，欢迎通过邮件与我们联系。
            </p>
            <a
              href="mailto:hello@seseshipin.example.com"
              className="focus-ring mt-3 inline-flex items-center gap-2 rounded-md border border-background-50/20 px-3 py-2 text-xs text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              <i className="ri-mail-line text-sm" aria-hidden="true" />
              hello@seseshipin.example.com
            </a>
            <p className="mt-4 text-[11px] leading-relaxed text-background-400">
              本站不存储视频文件，亦不提供播放与下载入口。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="container-page flex flex-col items-center justify-between gap-2 py-4 text-[11px] text-background-400 sm:flex-row">
          <p>© 2026 色色视频 · 保留所有权利</p>
          <p>内容聚合演示站点 · 仅提供视频信息浏览</p>
        </div>
      </div>
    </footer>
  );
}